/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Mic2 = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m12 8-9.04 9.06a2.82 2.82 0 1 0 3.98 3.98L16 12" }],
    ["circle", { cx: "17", cy: "7", r: "5" }]
  ]
];

export { Mic2 as default };
//# sourceMappingURL=mic-2.js.map
